import { requestApi } from '@app/api';
import { withIdentityAccess } from '@app/api/paths';

/**
 * PUT 설문 저장
 * @params {object} survey - 설문
 * @params {string} survey.user_type - 유저 타입
 * @params {string} survey.city - 지역
 * @params {?string} survey.company_name - 회사 이름
 * @params {?string} survey.company_scale - 회사 규모
 * @params {?string} survey.company_category - 회사 카테고리
 * @params {?string} survey.department - 부서
 * @return {object} - 처리결과
 * @property {string} message - 결과 메세지
 * @property {object} result
 * @property {string} result.requestId - 요청 id
 * @property {string} result.requestedAt - 요청 시간
 * @property {object} result.survey - 설문 결과
 * @property {string} result.survey.userType - 유저 타입
 * @property {string} result.survey.city - 지역
 * @property {?string} result.survey.companyName - 회사 이름
 * @property {?string} result.survey.companyScale - 회사 규모
 * @property {?string} result.survey.companyCategory - 회사 카테고리
 * @property {?string} result.survey.department - 부서
 * @property {string} result.survey.userId - 유저 id
 * @property {string} result.survey.updatedAt - 수정일
 * @property {string} result.survey.createdAt - 작성일
 */
// eslint-disable-next-line import/prefer-default-export
export function putSurvey(survey: {
  companyCategory?: string;
  companyName?: string;
  companyScale?: string;
  department?: string;
  phoneNumber: string;
  userType: string;
}) {
  return requestApi({
    url: withIdentityAccess('/survey'),
    method: 'PUT',
    data: survey,
    credentials: true,
  });
}
